import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { AdapterFactory, withValidation, withError } from '@bingads-webui-react/validation';
import { Input, Select } from '@bingads-webui-react/primitive';
import { buildUrl } from './build-url';
import { parseUrl } from './parse-url';

const protocols = [{
  value: 'https',
  text: 'https://',
}, {
  value: 'http',
  text: 'http://',
}];

export class UrlEditor extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    containerClassName: PropTypes.string,
    selectClassName: PropTypes.string,
    inputClassName: PropTypes.string,
    url: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    protocols: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    })),
    ariaProtocolLabelledBy: PropTypes.string,
    ariaUrlLabelledBy: PropTypes.string,
    ariaProtocolLabel: PropTypes.string,
    ariaUrlLabel: PropTypes.string,
  };

  static defaultProps = {
    id: undefined,
    containerClassName: undefined,
    selectClassName: undefined,
    inputClassName: undefined,
    url: '',
    protocols,
    ariaProtocolLabelledBy: undefined,
    ariaUrlLabelledBy: undefined,
    ariaProtocolLabel: undefined,
    ariaUrlLabel: undefined,
  };

  constructor(props) {
    super(props);
    let { protocol, url } = parseUrl(props.url);
    protocol = protocol || _.first(props.protocols).value;
    url = url || '';
    this.state = { protocol, url };
  }

  onUrlChange = (url) => {
    this.props.onChange(url);
  };

  onUrlPartChange = (e) => {
    const rawInput = e.target.value;
    let { protocol, url } = parseUrl(rawInput);
    if (!protocol || (protocol && !_.findWhere(this.props.protocols, { value: protocol }))) {
      // ignoring not supported protocols
      // and keeping URL input's value
      protocol = null;
      url = rawInput;
    }

    const newUrl = url || '';
    const newProtocol = protocol || this.state.protocol;

    const fullUrl = url ? this.buildFullUrl({
      protocol: newProtocol,
      url: newUrl.trim(),
    }) : '';

    this.setState({ url: newUrl, protocol: newProtocol });
    this.onUrlChange(fullUrl);
  };

  onProtocolPartChange = (e) => {
    e.stopPropagation();
    const protocol = e.target.value;
    const url = this.state.url.trim();

    const fullUrl = url ? this.buildFullUrl({
      protocol,
      url,
    }) : '';

    this.setState({ protocol });
    this.onUrlChange(fullUrl);
  };

  buildFullUrl = ({ protocol, url }) => buildUrl({ protocol, url, protocols: this.props.protocols });

  render() {
    const { protocol, url } = this.state;

    return (
      <div className={this.props.containerClassName}>
        <Select
          id={this.props.id}
          className={this.props.selectClassName}
          value={protocol}
          onChange={this.onProtocolPartChange}
          {...this.props.ariaProtocolLabelledBy ? {
            'aria-labelledby': this.props.ariaProtocolLabelledBy,
          } : {}}
          {...this.props.ariaProtocolLabel ? {
            'aria-label': this.props.ariaProtocolLabel,
          } : {}}
        >
          {this.props.protocols.map(option => (
            <option key={option.value} value={option.value}>{option.text}</option>
          ))}
        </Select>
        <Input
          className={this.props.inputClassName}
          value={url}
          onChange={this.onUrlPartChange}
          {...this.props.ariaUrlLabelledBy ? {
            'aria-labelledby': this.props.ariaUrlLabelledBy,
          } : {}}
          {...this.props.ariaUrlLabel ? {
            'aria-label': this.props.ariaUrlLabel,
          } : {}}
        />
      </div >
    );
  }
}

const UrlEditorValidationAdapter = AdapterFactory({
  valueToInject: 'url',
});

export const UrlEditorWithValidation = withError(withValidation(
  UrlEditor,
  UrlEditorValidationAdapter
));
